jQuery(function ($) {
    $(function () { /* カテゴリートグル */
        $('#categories .category-title').click(function () {
            $(this).next().slideToggle();
            $(this).toggleClass("open");
        });
    });
});
